
















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import ResearchReport from '../stadium/research_report_edit.vue';

@Component({
  components: {
    ResearchReport,
  },
})
export default class extends Mixins(MyForm) {
    @Prop() stadiumId!: number

    handleSubmit(name: string) {
      if (name == 'allow') {
        // 通过
        this.showTsConfirm({
          title: '确认信息',
          content: '你确定要审核通过吗？',
          onOk: async () => {
            const res = await this.$store.dispatch('enterapply/auditResearchReport', {
              stadium_id: this.stadiumId,
              audit_status: 1,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      } else {
        // 不通过
        this.showTsConfirm({
          title: '确认信息',
          content: '你确定要审核不通过吗？',
          onOk: async () => {
            const res = await this.$store.dispatch('enterapply/auditResearchReport', {
              stadium_id: this.stadiumId,
              audit_status: 2,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    }
}
